module.exports = __webpack_public_path__ + "img/mobile.7b6a4eee.jpg";